const getStyles = () => {
  return {
    // Main Container
    container: {
      minHeight: '100vh',
      backgroundColor: '#ffffff',
      color: '#1a202c',
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    },

    // Section Common Styles
    section: {
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '80px 16px',
      position: 'relative',
      overflow: 'hidden'
    },

    // Hero Section
    heroSection: {
      background:
        'linear-gradient(135deg, #0a0e27 0%, #1a1f3a 25%, #0d1229 50%, #1a1f3a 75%, #0a0e27 100%)',
      backgroundSize: '400% 400%',
      animation: 'gradientAnimation 15s ease infinite'
    },
    heroGradient: {
      position: 'absolute',
      inset: 0,
      background:
        'radial-gradient(circle at 30% 50%, rgba(102, 126, 234, 0.15) 0%, transparent 50%), radial-gradient(circle at 70% 50%, rgba(236, 72, 153, 0.1) 0%, transparent 50%)',
      opacity: 1
    },
    heroGlow1: {
      position: 'absolute',
      top: '10%',
      right: '10%',
      width: '600px',
      height: '600px',
      background:
        'radial-gradient(circle, rgba(102, 126, 234, 0.4) 0%, transparent 70%)',
      borderRadius: '50%',
      filter: 'blur(100px)',
      animation: 'float 8s ease-in-out infinite'
    },
    heroGlow2: {
      position: 'absolute',
      bottom: '10%',
      left: '10%',
      width: '500px',
      height: '500px',
      background:
        'radial-gradient(circle, rgba(236, 72, 153, 0.3) 0%, transparent 70%)',
      borderRadius: '50%',
      filter: 'blur(100px)',
      animation: 'float 10s ease-in-out infinite reverse'
    },
    heroGlow3: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '800px',
      height: '800px',
      background:
        'radial-gradient(circle, rgba(0, 180, 255, 0.15) 0%, transparent 70%)',
      borderRadius: '50%',
      filter: 'blur(120px)',
      animation: 'pulse 6s ease-in-out infinite'
    },
    containerWrapper: {
      position: 'relative',
      zIndex: 10,
      maxWidth: '1200px',
      margin: '0 auto',
      width: '100%'
    },
    heroImageContainer: {
      display: 'flex',
      justifyContent: 'center',
      paddingBottom: '30px',
      position: 'relative',
      zIndex: 10
    },
    phoneContainer: {
      position: 'relative',
      textAlign: 'center'
    },
    phoneGlow: {
      position: 'absolute',
      inset: '-20px',
      background:
        'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
      borderRadius: '48px',
      filter: 'blur(40px)',
      opacity: 0.7,
      animation: 'rotate 10s linear infinite'
    },
    phoneShadow: {
      position: 'absolute',
      inset: 0,
      boxShadow:
        '0 30px 60px -15px rgba(102, 126, 234, 0.6), 0 0 100px rgba(236, 72, 153, 0.3)',
      borderRadius: '48px',
      opacity: 0.8
    },
    heroPhone: {
      position: 'relative',
      width: '785px',
      maxWidth: '100%',
      borderRadius: '48px',
      boxShadow:
        '0 30px 60px -15px rgba(0, 0, 0, 0.4), inset 0 0 0 1px rgba(255, 255, 255, 0.1)',
      border: '2px solid rgba(102, 126, 234, 0.3)',
      transition: 'all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)',
      filter: 'brightness(1.05)'
    },
    heroContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '32px',
      position: 'relative',
      zIndex: 10,
      marginTop: '40px'
    },
    heroTitle: {
      fontSize: '45px',
      fontWeight: 'bold',
      lineHeight: 1.2,
      color: '#ffffff',
      textAlign: 'center',
      textShadow:
        '0 0 40px rgba(102, 126, 234, 0.5), 0 0 80px rgba(236, 72, 153, 0.3)',
      animation: 'textGlow 3s ease-in-out infinite alternate',
      margin: 0
    },
    gradientText: {
      background:
        'linear-gradient(135deg, #667eea 0%, #00b4ff 50%, #f093fb 100%)',
      backgroundSize: '200% 200%',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      animation: 'gradientShift 5s ease infinite',
      filter: 'drop-shadow(0 0 20px rgba(102, 126, 234, 0.5))'
    },
    infoCard: {
      background:
        'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)',
      backdropFilter: 'blur(20px) saturate(180%)',
      borderRadius: '24px',
      padding: '32px',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      boxShadow:
        '0 8px 32px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      textAlign: 'center',
      gap: '32px',
      transition: 'all 0.3s ease'
    },
    infoItem: {
      minWidth: '200px'
    },
    infoLabel: {
      fontSize: '14px',
      color: 'rgba(255, 255, 255, 0.7)',
      fontWeight: 500,
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      marginBottom: '18px'
    },
    badgesContainer: {
      display: 'flex',
      gap: '10px',
      flexWrap: 'wrap',
      justifyContent: 'center'
    },
    primaryBadge: {
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: '#ffffff',
      fontWeight: 600,
      fontSize: '1rem',
      padding: '10px 22px',
      borderRadius: '12px',
      boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
      transition: 'all 0.3s ease',
      cursor: 'pointer',
      display: 'inline-block'
    },
    outlineBadge: {
      border: '2px solid rgba(102, 126, 234, 0.5)',
      backgroundColor: 'rgba(102, 126, 234, 0.1)',
      color: 'rgba(255, 255, 255, 0.95)',
      borderRadius: '12px',
      padding: '8px 16px',
      transition: 'all 0.3s ease',
      cursor: 'pointer',
      display: 'inline-block',
      fontSize: '0.95rem'
    },
    accentBadge: {
      border: '2px solid rgba(236, 72, 153, 0.5)',
      backgroundColor: 'rgba(236, 72, 153, 0.1)',
      color: 'rgba(255, 255, 255, 0.95)',
      borderRadius: '12px',
      padding: '8px 16px',
      transition: 'all 0.3s ease',
      cursor: 'pointer',
      display: 'inline-block',
      fontSize: '0.95rem'
    },

    // Overview Section
    overviewSection: {
      background:
        'linear-gradient(180deg, #ffffff 0%, #f8fafc 50%, #ffffff 100%)'
    },
    overviewGradient: {
      position: 'absolute',
      inset: 0,
      background:
        'radial-gradient(circle at 50% 50%, rgba(102, 126, 234, 0.03) 0%, transparent 70%)'
    },
    overviewGlow: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '1000px',
      height: '1000px',
      background:
        'radial-gradient(circle, rgba(102, 126, 234, 0.08) 0%, transparent 70%)',
      borderRadius: '50%',
      filter: 'blur(100px)',
      animation: 'pulse 8s ease-in-out infinite'
    },
    overviewGrid: {
      position: 'relative',
      zIndex: 10,
      maxWidth: '1200px',
      margin: '0 auto',
      width: '100%'
    },
    overviewContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '32px'
    },
    sectionHeader: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px'
    },
    accentLine: {
      height: '5px',
      width: '100px',
      background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
      borderRadius: '10px',
      boxShadow: '0 2px 10px rgba(102, 126, 234, 0.4)',
      animation: 'expandLine 2s ease-in-out infinite alternate'
    },
    sectionTitle: {
      fontSize: '3rem',
      fontWeight: 'bold',
      background: 'linear-gradient(135deg, #1a202c 0%, #667eea 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      letterSpacing: '-0.02em',
      margin: 0
    },
    textContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '24px'
    },
    sectionText: {
      fontSize: '1.25rem',
      color: '#6b7280',
      lineHeight: 1.8,
      margin: 0
    },
    highlightedText: {
      color: '#667eea',
      fontWeight: 700,
      position: 'relative'
    },
    boldText: {
      color: '#667eea',
      fontWeight: 700,
      textShadow: '0 0 20px rgba(102, 126, 234, 0.3)'
    },
    overviewImageContainer: {
      display: 'flex',
      justifyContent: 'center',
      perspective: '1000px'
    },
    overviewImageWrapper: {
      position: 'relative',
      width: '100%',
      maxWidth: '600px',
      transition: 'transform 0.5s ease'
    },
    overviewImageGlow: {
      position: 'absolute',
      inset: '-20px',
      background:
        'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
      borderRadius: '32px',
      filter: 'blur(60px)',
      opacity: 0.5,
      transition: 'all 0.5s ease'
    },
    overviewHoverGlow: {
      position: 'absolute',
      inset: '-20px',
      background:
        'linear-gradient(135deg, rgba(102, 126, 234, 0.2) 0%, rgba(236, 72, 153, 0.2) 100%)',
      borderRadius: '32px',
      opacity: 0,
      transition: 'opacity 0.5s ease'
    },
    overviewImage: {
      position: 'relative',
      width: '100%',
      borderRadius: '32px',
      boxShadow:
        '0 30px 60px -15px rgba(0, 0, 0, 0.3), 0 0 40px rgba(102, 126, 234, 0.2)',
      border: '2px solid rgba(102, 126, 234, 0.2)',
      transition: 'all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)',
      height: '340px'
    },

    // Approach Section
    approachSection: {
      background:
        'linear-gradient(135deg, #0a0e27 0%, #1a1f3a 25%, #0d1229 50%, #1a1f3a 75%, #0a0e27 100%)',
      backgroundSize: '400% 400%',
      animation: 'gradientAnimation 20s ease infinite'
    },
    approachGradient: {
      position: 'absolute',
      inset: 0,
      background:
        'radial-gradient(circle at 70% 30%, rgba(236, 72, 153, 0.15) 0%, transparent 50%), radial-gradient(circle at 30% 70%, rgba(102, 126, 234, 0.1) 0%, transparent 50%)',
      opacity: 1
    },
    approachGlow1: {
      position: 'absolute',
      bottom: '15%',
      left: '10%',
      width: '600px',
      height: '600px',
      background:
        'radial-gradient(circle, rgba(236, 72, 153, 0.3) 0%, transparent 70%)',
      borderRadius: '50%',
      filter: 'blur(100px)',
      animation: 'float 12s ease-in-out infinite'
    },
    approachGlow2: {
      position: 'absolute',
      top: '20%',
      right: '10%',
      width: '500px',
      height: '500px',
      background:
        'radial-gradient(circle, rgba(102, 126, 234, 0.25) 0%, transparent 70%)',
      borderRadius: '50%',
      filter: 'blur(100px)',
      animation: 'float 10s ease-in-out infinite reverse'
    },
    approachGrid: {
      position: 'relative',
      zIndex: 10,
      maxWidth: '1200px',
      margin: '0 auto',
      width: '100%'
    },
    approachContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '32px'
    },
    approachAccentLine: {
      height: '5px',
      width: '100px',
      background: 'linear-gradient(90deg, #f093fb 0%, #f5576c 100%)',
      borderRadius: '10px',
      boxShadow: '0 2px 15px rgba(240, 147, 251, 0.5)',
      animation: 'expandLine 2s ease-in-out infinite alternate'
    },
    approachTitle: {
      fontSize: '3rem',
      fontWeight: 'bold',
      color: '#ffffff',
      textShadow: '0 0 40px rgba(102, 126, 234, 0.5)',
      margin: 0
    },
    approachText: {
      fontSize: '1.25rem',
      color: 'rgba(255, 255, 255, 0.9)',
      lineHeight: 1.8,
      margin: 0
    },
    glowText: {
      color: '#64ffda',
      fontWeight: 600
    },
    accentTextSpan: {
      color: '#f093fb',
      fontWeight: 600
    },
    scrollArea: {
      height: '550px',
      width: '100%',
      borderRadius: '32px',
      border: '2px solid rgba(102, 126, 234, 0.4)',
      background:
        'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)',
      backdropFilter: 'blur(20px) saturate(180%)',
      boxShadow:
        '0 8px 32px rgba(0, 0, 0, 0.3), 0 0 60px rgba(102, 126, 234, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
      transition: 'all 0.3s ease',
      overflow: 'auto'
    },
    scrollContent: {
      padding: '30px'
    },
    approachImageWrapper: {
      position: 'relative',
      transition: 'transform 0.5s ease'
    },
    approachImageGlow: {
      position: 'absolute',
      inset: '-30px',
      background:
        'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
      borderRadius: '24px',
      filter: 'blur(60px)',
      opacity: 0.6,
      transition: 'all 0.5s ease'
    },
    approachImage: {
      position: 'relative',
      width: '100%',
      borderRadius: '24px',
      boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.4)',
      border: '2px solid rgba(102, 126, 234, 0.3)',
      transition: 'all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)'
    },

    // Animations
    '@keyframes gradientAnimation': {
      '0%': { backgroundPosition: '0% 50%' },
      '50%': { backgroundPosition: '100% 50%' },
      '100%': { backgroundPosition: '0% 50%' }
    },
    '@keyframes float': {
      '0%, 100%': { transform: 'translate(0, 0)' },
      '50%': { transform: 'translate(30px, -30px)' }
    },
    '@keyframes pulse': {
      '0%, 100%': { opacity: 0.6, transform: 'translate(-50%, -50%) scale(1)' },
      '50%': { opacity: 1, transform: 'translate(-50%, -50%) scale(1.1)' }
    },
    '@keyframes rotate': {
      '0%': { transform: 'rotate(0deg)' },
      '100%': { transform: 'rotate(360deg)' }
    },
    '@keyframes textGlow': {
      '0%': {
        textShadow:
          '0 0 40px rgba(102, 126, 234, 0.5), 0 0 80px rgba(236, 72, 153, 0.3)'
      },
      '100%': {
        textShadow:
          '0 0 60px rgba(102, 126, 234, 0.8), 0 0 100px rgba(236, 72, 153, 0.5)'
      }
    },
    '@keyframes gradientShift': {
      '0%': { backgroundPosition: '0% 50%' },
      '50%': { backgroundPosition: '100% 50%' },
      '100%': { backgroundPosition: '0% 50%' }
    },
    '@keyframes expandLine': {
      '0%': { width: '80px' },
      '100%': { width: '120px' }
    }
  };
};

export default getStyles;
